



// import React from "react";
// import { InView } from "react-intersection-observer";
// import "../styles/ApplicationTopHero.css";

// const ApplicationTopHero = () => {
//   const tickerItems = [
//     "Cloud-Native Engineering",
//     "Microservices Transition",
//     "Zero-Trust Infrastructure",
//     "Automated DevSecOps",
//     "Legacy-to-Cloud Modernization",
//     "Hyper-Scale Architecture",
//     "Digital Product Development"
//   ];

//   return (
//     <section className="application-top-hero" role="banner">
//       <div className="application-top-content-container">
//         <InView triggerOnce={true} threshold={0.1}>
//           {({ inView, ref }) => (
//             <header
//               ref={ref}
//               className={`application-top-content ${inView ? "animate" : ""}`}
//             >
//               <h1 id="application-top-title">
//                 Application Development and Modernization
//               </h1>
//             </header>
//           )}
//         </InView>
//       </div>

//       <div className="tech-ticker">
//         <div className="ticker-inner">
//           {/* We repeat the items to ensure a seamless loop */}
//           {[...tickerItems, ...tickerItems].map((item, index) => (
//             <React.Fragment key={index}>
//               <span className="dot"></span>
//               <span>{item}</span>
//             </React.Fragment>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ApplicationTopHero;













import React from "react";
import { InView } from "react-intersection-observer";
import "../styles/ApplicationTopHero.css";

const ApplicationTopHero = () => {
  const tickerItems = [
    "Cloud-Native Engineering",
    "Microservices Transition",
    "Zero-Trust Infrastructure",
    "Automated DevSecOps",
    "Legacy-to-Cloud Modernization",
    "Hyper-Scale Architecture",
    "Digital Product Development"
  ];

  return (
    <section className="application-top-hero" role="banner">
      <div className="application-top-content-container">
        <InView triggerOnce={true} threshold={0.1}>
          {({ inView, ref }) => (
            <header
              ref={ref}
              className={`application-top-content ${inView ? "animate" : ""}`}
            >
              <h1 id="application-top-title">
                Application Development and Modernization
              </h1>
            </header>
          )}
        </InView>
      </div>

      <div className="tech-ticker">
        <div className="ticker-inner">
          {/* Doubling items for seamless infinite scroll */}
          {[...tickerItems, ...tickerItems].map((item, index) => (
            <div className="ticker-item" key={index}>
              <span className="dot"></span>
              <span className="ticker-text">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApplicationTopHero;